<template>
  <!-- 选择器 -->
  <sui-mutil-select
    ref="select"
    v-model="_val"
    v-loading="loading"
    :style="{
      width: elWidth
    }"
    :name="name"
    :popper-class="_popperClass"
    :multiple="multiple"
    :disabled="elDisabled"
    :size="elSize"
    :clearable="clearable"
    :collapse-tags="collapseTags"
    :multiple-limit="multipleLimit"
    :autocomplete="autocomplete"
    :placeholder="_placeholder"
    :filterable="filterable"
    :optionsFilterable="optionsFilterable"
    :optionsFilterMethod="optionsFilterMethod"
    :optionsInputProps="optionsInputProps"
    :filter-method="_filterMethod"
    :allow-create="allowCreate"
    :loading-text="_loadingText"
    :no-data-text="_noDataText"
    :no-match-text="_noMatchText"
    :remote="remote"
    :remote-method="_remoteMethod"
    :autoRemoteOrFilter="autoRemoteOrFilter"
    :reserve-keyword="reserveKeyword"
    :default-first-option="defaultFirstOption"
    :popper-append-to-body="popperAppendToBody"
    :automatic-dropdown="automaticDropdown"
    :show-tag-tooltip="showTagTooltip"
    :tag-tooltip-max-width="tagTooltipMaxWidth"
    :options-width="optionsWidth"
    :options-max-width="optionsMaxWidth"
    :show-input-tooltip="showInputTooltip"
    :input-tooltip-max-width="inputTooltipMaxWidth"
    :case-sensitive="caseSensitive"
    :use-tag-ref="useTagRef"
    :tag-ref-label="$attrs.label"
    @remove-tag="(val) => $emit('remove-tag', val)"
    @clear="handleClear"
    @visible-change="visibleChange"
    @blur="handleBlur"
    @focus="handleFocus"
    @change="handleSelectChange"
  >
    <slot name="tooltip_tag" slot="tooltip_tag"></slot>
    <slot name="top" slot="top">
      <template v-if="checkAllBtnPosition === 'top' && optsFormat.length && !readonly">
        <!-- 全选反选按钮 -->
        <sui-button-group
          v-if="checkAll"
          ref="selectBtn"
          :btns="selectBtns"
          style="width: 100%; text-align: center; padding-top: 6px; padding-bottom: 2px"
        ></sui-button-group>
        <sui-line v-show="multiple && checkAll"></sui-line>
      </template>
    </slot>
    <div>
      <slot>
        <div
          v-if="useVirtual"
          ref="suiSelectBodyWrapper"
          class="sui-select__body-wrapper"
          :style="{ height: _bodyHeight }"
          @scroll="handleScroll"
        >
          <div :style="{ height: _virtualBodyHeight }" class="sui-select__virtual-wrapper">
            <div :style="{ transform: `translateY(${innerTop}px)` }">
              <slot name="virtual-option" :data="showVirtualData">
                <sui-option
                  v-for="opt in showVirtualData"
                  :key="opt[_valueKey]"
                  :value="opt[_valueKey]"
                  :label="getLabel(opt)"
                  :disabled="opt[disabledKey]"
                  :created="opt['created']"
                >
                  <el-tooltip :disabled="!showOptionTooltip" effect="dark" placement="top-start" :visible-arrow="false">
                    <span v-if="labelSeparater !== ' '">
                      {{ getLabel(opt) }}
                      <sui-tooltip ref="tooltip" popper-class="tips-item">
                        <span slot="content" class="tips-item-tooltip">
                          {{ opt.tips }}
                        </span>
                        <span v-if="opt && !!opt.tips" class="sui-icon-question-fill tips-icon"> </span>
                      </sui-tooltip>
                    </span>
                    <span v-else style="width: calc(100% - 30px)">
                      <span style="float: left">{{ blankSeperatorLabel(opt)[0] }}</span>
                      <span style="float: right">{{ blankSeperatorLabel(opt)[1] }}</span>
                    </span>
                    <div slot="content" style="max-width: 100%">
                      {{ getLabel(opt) }}
                    </div>
                  </el-tooltip>
                </sui-option>
              </slot>
              <li v-if="noMore">
                <slot name="noMoreText">
                  <div class="sui-select-no-more">
                    {{ $t('sui.list.mei_you_geng_duo') }}
                  </div>
                </slot>
              </li>
            </div>
          </div>
        </div>
        <template v-else>
          <sui-option
            v-for="opt in optsFormat"
            :key="opt[_valueKey]"
            :value="opt[_valueKey]"
            :label="getLabel(opt)"
            :disabled="opt[disabledKey]"
          >
            <el-tooltip :disabled="!showOptionTooltip" effect="dark" placement="top-start" :visible-arrow="false">
              <span v-if="labelSeparater !== ' '">
                {{ getLabel(opt) }}
                <sui-tooltip ref="tooltip" popper-class="tips-item">
                  <span slot="content" class="tips-item-tooltip">
                    {{ opt.tips }}
                  </span>
                  <span v-if="opt && !!opt.tips" class="sui-icon-question-fill tips-icon"> </span>
                </sui-tooltip>
              </span>
              <span v-else style="width: calc(100% - 30px)">
                <span style="float: left">{{ blankSeperatorLabel(opt)[0] }}</span>
                <span style="float: right">{{ blankSeperatorLabel(opt)[1] }}</span>
              </span>
              <div slot="content" style="max-width: 100%">
                {{ getLabel(opt) }}
              </div>
            </el-tooltip>
          </sui-option>
        </template>
      </slot>
    </div>
    <slot name="bottom" slot="bottom">
      <template v-if="checkAllBtnPosition === 'bottom' && optsFormat.length && !readonly">
        <!-- 全选反选按钮 -->
        <sui-line v-show="multiple && checkAll"></sui-line>
        <sui-button-group
          v-if="checkAll"
          ref="selectBtn"
          :btns="selectBtns"
          style="width: 100%; text-align: center; padding-top: 2px; padding-bottom: 6px"
        ></sui-button-group>
      </template>
    </slot>
  </sui-mutil-select>
</template>
<script>
import { indexOf, filter, cloneDeep } from 'lodash-es'
import formMixin from './formMixin'
import { splitStringToArr, splitArrToString } from '../../utils/utils.js'
import { repairPx } from '../../utils/style.js'
export default {
  name: 'SuiSelect',
  components: {},
  mixins: [formMixin],
  props: {
    name: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default: null
    },
    opts: {
      type: Array,
      default: null
    },
    // 指定value的key
    valueKey: {
      type: String,
      default: 'value'
    },
    // 展示label的key ["value", "label"]
    labelKey: {
      type: [String, Array],
      default: 'label'
    },
    // 获取单个选项禁用的key
    disabledKey: {
      type: String,
      default: 'disabled'
    },
    // 展示label多个key时的分隔符
    labelSeparater: {
      type: String,
      default: '-'
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    reserveKeyword: {
      type: Boolean,
      default: false
    },
    defaultFirstOption: {
      type: Boolean,
      default: false
    },
    popperAppendToBody: {
      type: Boolean,
      default: true
    },
    automaticDropdown: {
      type: Boolean,
      default: false
    },
    dict: {
      type: String,
      default: ''
    },
    loadFilter: {
      type: [String, Array, Function],
      default: null
    },
    clearable: {
      type: Boolean
    },
    collapseTags: {
      type: Boolean
    },
    multiple: {
      type: Boolean
    },
    multipleLimit: {
      type: Number,
      default: 0
    },
    filterable: {
      type: Boolean,
      default: true
    },
    filterMethod: {
      type: Function,
      default: null
    },
    optionsFilterable: {
      type: Boolean,
      default: false
    },
    optionsFilterMethod: {
      type: Function,
      default: null
    },
    optionsInputProps: {
      type: Object,
      default: () => ({})
    },
    allowCreate: {
      type: Boolean,
      default: null
    },
    loading: {
      type: Boolean,
      default: null
    },
    loadingText: {
      type: String,
      default: ''
    },
    noMatchText: {
      type: String,
      default: ''
    },
    noDataText: {
      type: String,
      default: ''
    },
    popperClass: {
      type: String,
      default: ''
    },
    remote: {
      type: Boolean,
      default: false
    },
    remoteMethod: {
      type: Function,
      default: null
    },
    remoteDelay: {
      type: Number,
      default: 0
    },
    // 第一次触发时自动搜索或过滤
    autoRemoteOrFilter: {
      type: Boolean,
      default: false
    },
    // 是否默认选中第一个
    autoSelect: {
      type: Boolean,
      default: null
    },
    // 是否显示多选时的全选按钮
    checkAll: {
      type: Boolean,
      default: false
    },
    // 全选按钮的位置
    checkAllBtnPosition: {
      type: String,
      default: 'bottom'
    },
    optionsWidth: {
      type: String,
      default: ''
    },
    optionsMaxWidth: {
      type: String,
      default: ''
    },
    showOptionTooltip: {
      type: Boolean,
      default: false
    },
    showTagTooltip: {
      type: Boolean,
      default: true
    },
    tagTooltipMaxWidth: {
      type: String,
      default: undefined
    },
    tagTooltipMaxHeight: {
      type: String,
      default: undefined
    },
    showInputTooltip: {
      type: Boolean,
      default: false
    },
    inputTooltipMaxWidth: {
      type: String,
      default: undefined
    },
    isMultipleStringValue: {
      type: Boolean,
      default: false
    },
    useVirtual: {
      type: Boolean,
      reqiured: false,
      default: false
    },
    excessRows: {
      type: Number,
      default: 3
    },
    visibleCount: {
      type: Number,
      default: 7
    },
    showNoMore: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    caseSensitive: {
      type: Boolean,
      default: false
    },
    useTagRef: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectBtns: [
        {
          key: 'selectAll',
          text: '$t[sui.select.quanxuan]',
          type: null,
          size: 'small',
          click: this.handleSelectAll
        },
        {
          key: 'inverse',
          text: '$t[sui.select.fanxuan]',
          type: null,
          size: 'small',
          click: this.handleInverse
        }
      ],
      remoteOptions: null,
      bodyHeight: null, // 虚拟列表，表体高度
      _visibleCount: 10,
      rowHeight: 34,
      innerTop: 0,
      scrollTop: 0,
      scrollLeft: 0,
      start: 0,
      end: 0,
      noMore: false,
      virtualFilterKey: '',
      optsFormatCopy: []
    }
  },
  computed: {
    val: {
      get() {
        if (this.prop && this.SuiForm) {
          return this.SuiForm.model[this.prop]
        } else {
          return this.value
        }
      },
      set(val) {
        if (this.prop && this.SuiForm) {
          this.SuiForm.model[this.prop] = val
        } else {
          this.$emit('input', val)
        }
      }
    },
    _val: {
      get() {
        if (this.multiple && this.isMultipleStringValue && typeof this.val === 'string') {
          let val = splitStringToArr(this.val)
          return val
        }
        return this.val
      },
      set(val) {
        if (this.multiple && this.isMultipleStringValue && Array.isArray(val)) {
          val = splitArrToString(val)
        }
        this.val = val
      }
    },
    _valueKey() {
      if (!this.$options.propsData.valueKey && this.dict) {
        return 'dictItem'
      } else {
        return this.valueKey
      }
    },
    _labelKey() {
      if (!this.$options.propsData.labelKey && this.dict) {
        return 'dictItemName'
      } else {
        return this.labelKey
      }
    },
    _options() {
      return this.options || this.opts || this.remoteOptions
    },
    optsFormat() {
      let options = []
      if (Array.isArray(this._options)) {
        options = this._options
      } else if (this.dict && this.$dict) {
        options = this.$dict.getOpts(this.dict)
      }
      if (typeof this.loadFilter === 'string') {
        let inverse = this.loadFilter.charAt('0') === '!'
        let filterArr = this.loadFilter.replace('!', '').split(/[,\\|]/)
        options = filter(options, (opt) => {
          return inverse ? indexOf(filterArr, opt[this._valueKey]) === -1 : indexOf(filterArr, opt[this._valueKey]) !== -1
        })
      } else if (typeof this.loadFilter === 'function') {
        options = this.loadFilter(options)
      } else if (Array.isArray(this.loadFilter)) {
        options = filter(options, (opt) => {
          return indexOf(this.loadFilter, opt[this._valueKey]) !== -1
        })
      }
      if (this.readonly) {
        options = options.map((item) => {
          return {
            ...item,
            [this.disabledKey]: true
          }
        })
      }
      return options
    },
    _remoteMethod() {
      if (!this.remote) {
        return null
      } else {
        return this.remoteMethodReform
      }
    },
    _placeholder() {
      if (this.placeholder !== '' && this.placeholder !== null) {
        return this._locale(this.placeholder)
      } else if (this.placeholder === '') {
        return ''
      } else {
        return undefined
      }
    },
    _noMatchText() {
      if (this.noMatchText) {
        return this.noMatchText
      } else {
        return this._locale('$t[sui.select.wupipeishuju]')
      }
    },
    _loadingText() {
      if (this.loadingText) {
        return this.loadingText
      } else {
        return this._locale('$t[sui.select.jiazaizhong]')
      }
    },
    _noDataText() {
      if (this.noDataText) {
        return this.noDataText
      } else {
        return this._locale('$t[sui.select.wushuju]')
      }
    },
    _popperClass() {
      if (this.multiple && this.checkAll) {
        return this.popperClass + ' checkAll'
      } else if (this.popperClass === '' && this.useVirtual) {
        return 'sui-select__virtual'
      } else {
        return this.popperClass
      }
    },

    virtualBodyHeight() {
      if (this.virtualFilterKey) {
        return this.optsFormatCopy ? this.optsFormatCopy.length * this.rowHeight : 0
      } else {
        return this.optsFormat ? this.optsFormat.length * this.rowHeight : 0
      }
    },
    showVirtualData() {
      return this.getVirtualData()
    },
    _filterMethod() {
      if (typeof this.filterMethod === 'function') {
        return this.filterMethod
      } else if (this.useVirtual) {
        return this.virtualFilterMethod
      } else {
        return undefined
      }
    },
    _bodyHeight() {
      return this.showVirtualData.length < this._visibleCount ? 'auto' : repairPx(this.bodyHeight)
    },
    _virtualBodyHeight() {
      return this.showVirtualData.length < this._visibleCount ? 'auto' : repairPx(this.virtualBodyHeight)
    }
  },
  watch: {
    multiple(multiple) {
      if (multiple) {
        this.val = Array.isArray(this.val) ? this.val : this.val ? [this.val] : []
      } else {
        this.val = Array.isArray(this.val) ? this.val[0] : this.val
      }
    },
    scrollTop: {
      immediate: true,
      handler(top) {
        if (this.useVirtual) {
          if (parseFloat(top) <= 0) {
            this.scrollTop = 0
          }
          this.computeScrollToRow(top)
        }
      }
    },
    bodyHeight: {
      immediate: false,
      handler() {
        if (this.showNoMore && this.bodyHeight < this.virtualBodyHeight) {
          this.noMore = true
        }
        if (this.useVirtual) {
          this.computeScrollToRow(this.scrollTop)
        }
      }
    },
    readonly: {
      immediate: true,
      handler(val) {
        this.$nextTick(() => {
          if (!this.$el) return
          const inputDom = this.$el.getElementsByClassName('el-input__inner')[0]
          if (!inputDom) return
          inputDom.style.backgroundColor = val ? '#EEEEEE' : ''
          inputDom.style.borderColor = val ? '#DDDFE6' : ''
          if (val) {
            inputDom.classList.add('readonly')
          } else {
            inputDom.classList.remove('readonly')
          }
        })
      }
    }
  },
  created() {
    this.calcBodyHeight()
    if (this.multiple && !Array.isArray(this.val)) {
      if (!this.isMultipleStringValue) {
        this.val = this.val === '' ? [] : [this.val]
      }
    }
    if (this.autoSelect) {
      if (this.multiple) {
        if (this.val[0] === undefined && this.optsFormat && this.optsFormat.length) {
          this.val = [this.optsFormat[0][this._valueKey]]
        }
      } else {
        if (this.val === '' && this.optsFormat && this.optsFormat.length) {
          this.val = this.optsFormat[0][this._valueKey]
        }
      }
    }
    if (this.useVirtual) {
      // 初始化面板位置和数据
      let itemIndex = this.optsFormat.findIndex((data) => {
        const val = Array.isArray(this.val) ? this.val[0] : this.val
        return data[this.valueKey] + '' === val + ''
      })
      this.scrollTop = itemIndex * this.rowHeight
    }
  },
  mounted() {
    this.$nextTick(() => {})
  },
  methods: {
    virtualFilterMethod(val) {
      this.virtualFilterKey = val
      this.handleScroll({ target: this.$refs.suiSelectBodyWrapper }, true)
    },
    getVirtualData() {
      if (this.useVirtual) {
        let calRowsNum = this.end - this.start - this.excessRows - this.excessRows
        let standardRowsNum = this._visibleCount
        let sameItemPosition = 'bottom'
        let re = []

        let optsFormatCopy = cloneDeep(this.optsFormat)

        if (this.virtualFilterKey) {
          optsFormatCopy = optsFormatCopy.filter((item) => {
            const label = this.getLabel(item)
            if (label.indexOf(this.virtualFilterKey) > -1) {
              return true
            }
          })
        }
        this.optsFormatCopy = optsFormatCopy
        if (calRowsNum < standardRowsNum) {
          let num = standardRowsNum - calRowsNum
          if (this.start <= this.excessRows) {
            re = optsFormatCopy.slice(this.start, this.end + num)
          }
        } else {
          if (this.end > optsFormatCopy.length) {
            let num = this.end - optsFormatCopy.length
            sameItemPosition = 'top'
            const start = Math.max(this.start - num, 0)
            const end = Math.max(this.end - num, 0)
            re = optsFormatCopy.slice(start, end)
          } else {
            re = optsFormatCopy.slice(this.start, this.end)
          }
        }
        if (this.multiple) {
          for (let i = 0; i < this.val.length; i++) {
            let val = this.val[i]
            let item = optsFormatCopy.find((data) => {
              return data[this.valueKey] + '' === val + ''
            })
            let isSame = re.find((data) => {
              return data[this.valueKey] + '' === val + ''
            })
            if (item && !isSame) {
              item.created = true
              if (sameItemPosition === 'bottom') {
                re.push(item)
              } else {
                re = [item].concat(re)
              }
            }
          }
        } else {
          if (this.val) {
            let item = optsFormatCopy.find((data) => {
              return data[this.valueKey] + '' === this.val + ''
            })
            let isSame = re.find((data) => {
              return data[this.valueKey] + '' === this.val + ''
            })
            if (item && !isSame) {
              item.created = true
              if (sameItemPosition === 'bottom') {
                re.push(item)
              } else {
                re = [item].concat(re)
              }
            }
          }
        }
        return re
      } else {
        return this.optsFormat
      }
    },
    handleScroll(e, isForce) {
      const ele = e.srcElement || e.target
      if (this.useVirtual && ele) {
        let { scrollTop, scrollLeft } = ele
        if (isForce) {
          let itemIndex = this.optsFormat.findIndex((data) => {
            const val = Array.isArray(this.val) ? this.val[0] : this.val
            return data[this.valueKey] + '' === val + ''
          })
          scrollTop = itemIndex * this.rowHeight
          setTimeout(() => {
            ele.scrollTop = scrollTop
          }, 0)
        }
        const bodyScrollHeight = this.visibleCount * this.rowHeight

        if (this.virtualBodyHeight < scrollTop + bodyScrollHeight) {
          scrollTop = this.virtualBodyHeight - bodyScrollHeight
        }
        this.scrollTop = scrollTop
        this.scrollLeft = scrollLeft

        // 当表格滚动暴露滚动事件
        let copyTop = parseFloat(this.scrollTop <= 0) ? 0 : this.scrollTop
        const obj = {
          scrollTop: copyTop,
          scrollLeft: this.scrollLeft,
          list: this
        }
        this.$emit('listBodyScroll', obj, e)
      }
    },
    computeScrollToRow(scrollTop) {
      let startIndex = parseInt(scrollTop / this.rowHeight)

      const { start, end } = this.getVisibleRange(startIndex)

      this.start = start
      this.end = end

      if (this.optsFormat.length > this._visibleCount + this.excessRows && this.end > this.optsFormat.length) {
        let num = this.end - this.optsFormat.length
        this.innerTop = (this.start - num) * this.rowHeight
      } else {
        this.innerTop = this.start * this.rowHeight
      }
    },

    getVisibleRange(expectStart) {
      const start = expectStart - this.excessRows

      return {
        start: start >= 0 ? start : 0,
        end: expectStart + this._visibleCount + this.excessRows
      }
    },

    calcBodyHeight() {
      if (this.useVirtual) {
        this._visibleCount = this.visibleCount
        this.bodyHeight = this._visibleCount * (this.rowHeight || 34) + this._visibleCount
      }
    },

    handleInverse(val) {
      if (Array.isArray(this.optsFormat)) {
        let options = this.optsFormat
        let model = []
        let items = []
        if (Array.isArray(this.val)) {
          options.forEach((opt) => {
            if (!(opt[this._valueKey] && opt.disabled)) {
              if (this.val.indexOf(opt[this._valueKey]) === -1) {
                model.push(opt[this._valueKey])
                items.push(opt)
              }
            }
          })
        }
        this.val = cloneDeep(model)
        this.$nextTick(() => {
          this.$emit('select-change', this.val, items)
        })
      }
    },
    handleSelectAll(val) {
      if (Array.isArray(this.optsFormat)) {
        let options = this.optsFormat
        let model = []
        let items = []
        options.forEach((opt) => {
          if (!(opt[this._valueKey] && opt.disabled)) {
            model.push(opt[this._valueKey])
            items.push(opt)
          }
        })
        this.val = cloneDeep(model)
        this.$nextTick(() => {
          this.$emit('select-change', this.val, items)
        })
      }
    },
    getLabel(opt) {
      let textField = Array.isArray(this._labelKey) ? this._labelKey : this._labelKey.split(',')
      let label = textField
        .map((key) => {
          return opt[key]
        })
        .join(this.labelSeparater)
      return this._locale(label)
    },
    // 用空格分割时, option的label显示
    blankSeperatorLabel(opt) {
      let textField = Array.isArray(this._labelKey) ? this._labelKey : this._labelKey.split(',')
      return textField.map((key) => {
        return this._locale(opt[key])
      })
    },
    visibleChange(flag) {
      if (flag) {
        this.virtualFilterKey = ''
      }
      if (this.$refs.suiSelectBodyWrapper) {
        this.handleScroll({ target: this.$refs.suiSelectBodyWrapper }, true)
      }
      this.$emit('visible-change', flag, this.val)
    },
    handleSelectChange(val) {
      // readonly模式下保持值不变
      if (this.readonly) {
        const _val = this._val
        this.$nextTick(() => {
          this._val = _val
        })
      } else {
        if (this.multiple) {
          if (Array.isArray(this.optsFormat)) {
            let options = this.optsFormat
            let items = []
            if (Array.isArray(this.val)) {
              options.forEach((opt) => {
                if (!(opt[this._valueKey] && opt.disabled)) {
                  if (val.indexOf(opt[this._valueKey]) !== -1) {
                    items.push(opt)
                  }
                }
              })
            }
            this.$emit('select-change', val, items)
          }
        } else {
          let item = this.optsFormat.find((opt) => {
            return opt[this._valueKey] === val
          })
          this.$emit('select-change', val, item)
        }
      }
    },
    remoteMethodReform(val) {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.timer = null
        this.remoteMethod(val)
      }, this.remoteDelay)
    },
    handleClose() {
      this.$refs.select.handleClose()
    }
  }
}
</script>
<style lang="scss">
.el-select-dropdown.select-popper {
  .popper__arrow {
    display: none;
  }
  &.el-popper[x-placement^='bottom'] {
    margin-top: 8px;
  }
}
.sui-select__body-wrapper {
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(144, 147, 153, 0.3);
    border-radius: 3px;
    &:hover {
      background-color: rgba(144, 147, 153, 0.5);
    }
  }
}
.sui-select-no-more {
  text-align: center;
  padding: 10px 0;
  color: #cacaca;
}
.sui-select__virtual {
  .el-scrollbar__bar {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SimbartUI/components/form/SuiSelect.vue